import React from 'react';
import Icon from '../AppIcon';

const NavigationProgress = ({ steps, currentStep, onStepClick }) => {
  const getStepStatus = (stepIndex) => {
    if (stepIndex < currentStep) return 'completed';
    if (stepIndex === currentStep) return 'current';
    return 'upcoming';
  };

  const handleStepClick = (stepIndex, status) => {
    if (status === 'completed' && onStepClick) {
      onStepClick(stepIndex);
    }
  };

  return (
    <div className="w-full bg-card rounded-lg shadow-sm p-6 mb-6">
      <div className="hidden md:flex items-center justify-between">
        {steps?.map((step, index) => {
          const status = getStepStatus(index);
          const isClickable = status === 'completed';

          return (
            <React.Fragment key={step?.id}>
              <div className="flex flex-col items-center flex-1">
                <button
                  onClick={() => handleStepClick(index, status)}
                  disabled={!isClickable}
                  className={`flex items-center justify-center w-12 h-12 rounded-full border-2 transition-organic ${
                    status === 'completed'
                      ? 'bg-success border-success text-success-foreground cursor-pointer hover-lift active-press'
                      : status === 'current' ?'bg-primary border-primary text-primary-foreground' :'bg-muted border-border text-muted-foreground'
                  }`}
                  aria-label={`${step?.label} - ${status}`}
                >
                  {status === 'completed' ? (
                    <Icon name="Check" size={24} />
                  ) : (
                    <span className="text-sm font-semibold">{index + 1}</span>
                  )}
                </button>
                <span
                  className={`mt-2 text-sm font-medium text-center ${
                    status === 'current' ?'text-foreground'
                      : status === 'completed' ?'text-success' :'text-muted-foreground'
                  }`}
                >
                  {step?.label}
                </span>
                {step?.description && (
                  <span className="mt-1 text-xs text-muted-foreground text-center max-w-[120px]">
                    {step?.description}
                  </span>
                )}
              </div>
              {index < steps?.length - 1 && (
                <div className="flex-1 h-0.5 mx-4 mb-8">
                  <div
                    className={`h-full transition-organic ${
                      index < currentStep ? 'bg-success' : 'bg-border'
                    }`}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
      <div className="md:hidden">
        <div className="flex items-center justify-center space-x-2 mb-4">
          {steps?.map((step, index) => {
            const status = getStepStatus(index);
            return (
              <button
                key={step?.id}
                onClick={() => handleStepClick(index, status)}
                disabled={status !== 'completed'}
                className={`w-3 h-3 rounded-full transition-organic ${
                  status === 'completed'
                    ? 'bg-success cursor-pointer active-press'
                    : status === 'current' ?'bg-primary w-8' :'bg-border'
                }`}
                aria-label={`${step?.label} - ${status}`}
              />
            );
          })}
        </div>

        <div className="text-center">
          <h3 className="text-lg font-semibold text-foreground">
            {steps?.[currentStep]?.label}
          </h3>
          {steps?.[currentStep]?.description && (
            <p className="text-sm text-muted-foreground mt-1">
              {steps?.[currentStep]?.description}
            </p>
          )}
          <p className="text-xs text-muted-foreground mt-2">
            Step {currentStep + 1} of {steps?.length}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NavigationProgress;